class ProductPicker extends HTMLElement {
  siblingOptionsData = [];
  constructor() {
    super();
  }
  connectedCallback() {
    const optionValues = this.querySelectorAll("input.product-option-value");
    const scriptEl = this.querySelector('[data-sibling-metaobject]');
    if (!scriptEl) {
      console.error('[product-picker] data-sibling-metaobject script not found', this);
      return;
    }
    try {
      this.siblingOptionsData = JSON.parse(scriptEl.textContent);
    } catch (e) {
      console.error('[product-picker] JSON parse error:', e, '\nRaw JSON:', scriptEl.textContent);
      return;
    }

    this.checkAvailability(optionValues);

    const isCollectionPage = !!this.closest('.product-grid-item');
    for (const optionValue of optionValues) {
      optionValue.addEventListener("input", (event) => {
        if (isCollectionPage) {
          this.setProductOnTile(optionValues, event);
        } else {
          const [productUrl, sku] = this.getOptionHandle.call(this, optionValues, event);
          if (productUrl) {
            this.setProduct.call(this, productUrl, sku);
          }
        }
      });
    }
  }
  getSelectedValue(event, key, optionValues) {
    return event.target.dataset.key === key ?
      event.target.dataset.value :
      Array.from(optionValues).find( option => option.dataset.key === key && option.checked )?.dataset.value;
  }

  reduceOptionsBySelectedValues( event, optionValues ){
    let siblingOptions = [...this.siblingOptionsData];

    const selectedMaterial = this.getSelectedValue(event, "material", optionValues );
    const selectedColor = this.getSelectedValue(event, "color", optionValues );
    const selectedSize = this.getSelectedValue(event, "size", optionValues );

    if (selectedMaterial) {
      siblingOptions = siblingOptions.filter(option => option[ 'material' ] === selectedMaterial)
    }
    if (selectedColor) {
      siblingOptions = siblingOptions.filter( option => option[ 'color' ] === selectedColor)
    }
    if (selectedSize) {
      siblingOptions = siblingOptions.filter( option => option[ 'size' ] === selectedSize)
    }

    return siblingOptions;
  }
  getOptionHandle(optionValues, event){

    const eventKey = event.target.dataset.key;
    const eventValue = event.target.dataset.value;
    const inputValue = event.target.value;
    let siblingOptions = this.reduceOptionsBySelectedValues(event, optionValues);

    if ( siblingOptions.length === 0 ) {
      // no siblingOptionsAvailable
      // set siblingOptions by event
      siblingOptions = [...this.siblingOptionsData].filter(option => option[ eventKey ] === eventValue )
    }
    if ( !eventKey || !eventValue ) {
      const handle = inputValue?.split('/')?.pop() ?? undefined
      const handleWithoutParams = handle?.split('?')[0] ?? undefined
      const matchingSku = siblingOptions.filter(option => handleWithoutParams == option.handle)
      return [inputValue, matchingSku[0].sku ?? ""]
    }
    const path = document.location.pathname.split('/')
    path.splice(-1,1)
    path.push( siblingOptions[0].handle )
    return [path.join('/'), siblingOptions[0].sku]
  }

  checkAvailability(optionValues) {
    let siblingOptions = [...this.siblingOptionsData]
    const availableSiblings = [];
    const checkedOptions = this.querySelectorAll("input.product-option-value:checked");
    const availableOptions = [];

    if (checkedOptions.length === 0) return;

    for (const sibling of siblingOptions) {
      if ( sibling[checkedOptions[0].dataset.key] === checkedOptions[0].dataset.value ) {
        availableSiblings.push(sibling);
      }
    }

    for (let i = 0; i < optionValues.length ; i++) {
      if ( i === 0) {
        availableOptions.push(optionValues[i]);
      } else {
        const siblings = availableSiblings.filter( sibling => sibling[ optionValues[i].dataset.key ] === optionValues[i].dataset.value )
        for (const sibling of siblings) {
          if (optionValues[i].dataset.value === sibling[ optionValues[i].dataset.key ]) {
            availableOptions.push(optionValues[i]);
          }
        }
      }
    }

    let firstKey = optionValues[0].dataset.key;
    for (const optionValue of optionValues) {

      if ( optionValue.dataset.key === firstKey ) {
        optionValue.disabled = false;
        continue;
      }

      if (availableOptions.indexOf(optionValue) === -1) {
        optionValue.disabled = true;
      } else {
        optionValue.disabled = false;
      }
    }
  }

  getSectionId(section){
    if ( !section ) {
      return null;
    }
    const sectionId = section?.id?.split('shopify-section-')?.pop();

    if ( sectionId && sectionId !== '' ) {
      return sectionId;
    }

    return section.closest('[id^="shopify-section-"]')?.id?.split('shopify-section-')?.pop();
  }

  async fetcher(url) {
    try {
      return await fetch(url.href, {
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        method: "GET",
      })
        .then((response) => response.json())
    } catch (e) {
      this.classList.remove("loading");
      console.error(e);
      console.error(err);
    }
    return null;
  }
  async updateDOM(productUrl, variantSku) {

    const that = this;
    const dynamicId = that.closest(".shopify-section")?.id;
    const sectionId = that.dataset.sectionId;
    const newURL = new URL(productUrl, document.location.origin);
    const product_description_section = document.querySelector('section.shopify-section-product-richtext');
    const product_tabs_section = document.querySelector('section.shopify-section-product-tabs');
    const product_about_section = document.querySelector('shopify-section.shopify-section-product-about');
    const product_compare_section = document.querySelector('section.shopify-section-compare-products');
    const product_tabs_v2_section = document.querySelector('section.shopify-section-product-tabs-v2');
    const product_description_id = this.getSectionId(product_description_section);
    const product_tabs_id = this.getSectionId(product_tabs_section);
    const product_about_id = this.getSectionId(product_about_section);
    const product_compare_id = this.getSectionId(product_compare_section);
    const product_tabs_v2_id = this.getSectionId(product_tabs_v2_section);
    newURL.searchParams.set('sections', `${sectionId}${product_description_id ? ',' + product_description_id : ''}${product_tabs_id ? ',' + product_tabs_id : ''}${product_about_id ? ',' + product_about_id : ''}${product_compare_id ? ',' + product_compare_id : ''}${product_tabs_v2_id ? ',' + product_tabs_v2_id : ''}`);
    that.classList.add("loading");

    this.replaceAdditionalSections(productUrl)
    const data = await this.fetcher(newURL);

    if ( !data ) return false;

    try {
      const template = document.createElement("template");
      template.innerHTML = data[sectionId].trim();

      // replace product_main
      const newSection = template.content.querySelector(`#shopify-section-${sectionId}`);
      const oldSection = document.querySelector(`#shopify-section-${sectionId}`);
      if (that.hasAttribute("external")) {
        const newVariantPicker = template.content.querySelector('variant-picker');
        const oldVariantPicker = document.querySelector(`#${dynamicId} variant-picker`);
        const newProductPicker = template.content.querySelector('product-picker');
        const oldProductPicker = document.querySelector(`#${dynamicId} product-picker`);
        const newPriceWrapper = template.content.querySelector('.product-price-wrapper');
        const oldPriceWrapper = document.querySelector(`#${dynamicId} .product-price-wrapper`);
        const newProductOptionLabel = template.content.querySelector('.option-value-name');
        const oldProductOptionLabel = document.querySelector(`#${dynamicId} .option-value-name`);
        const newButtonRedirect = template.content.querySelector('.product-redirect-button');
        const oldButtonRedirect = document.querySelector(`#${dynamicId} .product-redirect-button`);
        const newProductTitle = template.content.querySelector('.product-title-wrapper .product-title');
        const oldProductTitle = document.querySelector(`#${dynamicId} .product-title-wrapper .product-title`);

        if (!!newProductTitle && !!oldProductTitle) {
          oldProductTitle.replaceWith(newProductTitle);
        }
        if (!!newButtonRedirect && !!oldButtonRedirect) {
          oldButtonRedirect.replaceWith(newButtonRedirect);
        }
        if (!!newVariantPicker && !!oldVariantPicker) {
          oldVariantPicker.replaceWith(newVariantPicker);
        } else if (!newVariantPicker && !!oldVariantPicker) {
          oldVariantPicker.style.display = 'none';
        } else if (!!newVariantPicker && !oldVariantPicker && !!oldProductPicker) {
          document.querySelector(`#${dynamicId} #current-variant`)?.remove();
          oldProductPicker.parentNode.insertBefore(newVariantPicker, oldProductPicker.nextSibling);
        }
        if (!!newProductPicker && !!oldProductPicker) {
          oldProductPicker.replaceWith(newProductPicker);
        }
        if (!!newPriceWrapper && !!oldPriceWrapper) {
          oldPriceWrapper.replaceWith(newPriceWrapper);
        }
        if (!!newProductOptionLabel && !!oldProductOptionLabel) {
          if (!document.body.contains(oldProductOptionLabel)) {
            const optionValueNameWrapper = document.querySelector(`#${dynamicId} .option-value-name-wrapper`);
            if (!!optionValueNameWrapper) {
              optionValueNameWrapper.appendChild(newProductOptionLabel);
            } else {
              console.log('Option value name wrapper not found');
            }
          } else {
            oldProductOptionLabel.replaceWith(newProductOptionLabel);
          }
        }
        const newVariantIdInput = template.content.querySelector('#current-variant');
        const oldVariantIdInput = document.querySelector(`#${dynamicId} #current-variant`);
        const newProductIdInput = template.content.querySelector('form [name="product-id"]');
        const oldProductIdInput = document.querySelector(`#${dynamicId} form [name="product-id"]`);
        if (!!newVariantIdInput && !!oldVariantIdInput) {
          oldVariantIdInput.replaceWith(newVariantIdInput);
        }
        if (!!newProductIdInput && !!oldProductIdInput) {
          oldProductIdInput.replaceWith(newProductIdInput);
        }
        window.dispatchEvent(new Event('product:changed'));
      } else if (!!oldSection && !!newSection) {
        oldSection.replaceWith(newSection);
      }

      ReviewsIoBadge?.getReviews();
      window.dispatchEvent(
        new CustomEvent("variant:changed", { bubbles: true, cancelable: false, detail: variantSku }),
      );

      // replace product description
      if (!!product_description_section && !!template.content.firstChild) {
        template.innerHTML = data[product_description_section.id.split('shopify-section-').pop()].trim();
        product_description_section.replaceWith(template.content.firstChild);
      }

      // replace ingredients
      if (!!product_tabs_section) {
        template.innerHTML = data[product_tabs_section.id.split('shopify-section-').pop()].trim();
        const ingredients_old = product_tabs_section.querySelector('.tab_wrapper.tab-ingredients');
        const ingredients_new = template.content.querySelector('.tab_wrapper.tab-ingredients');
        if (!!ingredients_old && !!ingredients_new) {
          const ingredients_old_content = ingredients_old.querySelector('.tab_content');
          const ingredients_new_content = ingredients_new.querySelector('.tab_content');
          ingredients_old_content.replaceWith(ingredients_new_content);
          ingredients_old.querySelector('.tab_content_wrapper').removeAttribute('style');
          ingredients_old.classList.remove('open');
          ingredients_old.classList.add('close');
        }
      }

      // replace product-tabs-v2 content
      if (!!product_tabs_v2_section) {
        const tabDrawerV2Id = this.getSectionId(product_tabs_v2_section);
        const tabDrawerV2El = product_tabs_v2_section.querySelector('tab-drawer-v2');
        if (data[tabDrawerV2Id] && tabDrawerV2El?.refreshFromHTML) {
          tabDrawerV2El.refreshFromHTML(data[tabDrawerV2Id]);
        }
      }

      // replace compare products section
      if (!!product_compare_section && !!product_compare_id && data[product_compare_id]) {
        template.innerHTML = data[product_compare_id].trim();
        const newCompareSection = template.content.firstChild;
        if (newCompareSection) {
          product_compare_section.replaceWith(newCompareSection);
        }
      }

      that.classList.remove("loading");
    } catch (e) {
      that.classList.remove("loading");
      console.error(e);
    }
  }
  replaceAdditionalSections(productUrl){
    const replaceSections = [
      this.sectionReplacer(productUrl, '.shopify-section.shopify-section-product-about'),
      this.sectionReplacer(productUrl, '.shopify-section.shopify-section-product-tabs'),
    ]

    Promise.all(replaceSections.map( async replaceSection => await replaceSection))
  }

  /**
   *
   * @param productUrl
   * @param sectionElementSelector
   * @returns {Promise<unknown>}
   */
  sectionReplacer(productUrl, sectionElementSelector ) {

    return new Promise(async (resolve, reject) => {

      try {
        const sectionElement = document.querySelector( sectionElementSelector );

        const sectionId = this.getSectionId(sectionElement);
        const newURL = new URL(productUrl, document.location.origin);
        newURL.searchParams.set('sections', `${sectionId}`);

        if ( sectionId ) {
          const data = await this.fetcher(newURL);
          const template = document.createElement("div");
          template.innerHTML = data[sectionId].trim();

          let oldSection = document.querySelector(`#shopify-section-${sectionId}`);

          if ( oldSection.querySelector( sectionElementSelector )) {
            oldSection = oldSection.querySelector( sectionElementSelector )
          }

          if (oldSection) {
            oldSection.parentNode.replaceChild(template.querySelector( sectionElementSelector ), oldSection);
          }
          resolve();
        }
      } catch (e) {
        console.log("##### fail", sectionElementSelector, e );
      }
      reject()
    })
  }
  updateURL(productUrl) {
    const newURL = new URL(productUrl, document.location.origin);
    history.replaceState(null, "", newURL.href);
  }
  setProductOnTile(optionValues, event) {
    const eventKey = event.target.dataset.key;
    const eventValue = event.target.dataset.value;

    let siblingOptions;
    if (!eventKey || !eventValue) {
      // Regular sibling mode: input value is the product URL, find sibling by handle
      const handle = event.target.value?.split('/')?.pop()?.split('?')[0];
      siblingOptions = handle
        ? [...this.siblingOptionsData].filter(o => o.handle === handle)
        : [];
    } else {
      // Metaobject mode: filter by data-key / data-value
      siblingOptions = this.reduceOptionsBySelectedValues(event, optionValues);
      if (siblingOptions.length === 0) {
        siblingOptions = [...this.siblingOptionsData].filter(o => o[eventKey] === eventValue);
      }
    }

    if (siblingOptions.length === 0) return;
    const sibling = siblingOptions[0];
    const gridItem = this.closest('.product-grid-item');
    const form = this.closest('form');

    const variantInput = form?.querySelector('[name="id"]');
    const img = gridItem?.querySelector('.grid-item-featured-image img');
    const priceEl = gridItem?.querySelector('.grid-item-product-price .price');

    if (variantInput && sibling.variant_id) {
      variantInput.value = sibling.variant_id;
    }

    const pw = img?.closest('picture-wrapper');

    if (gridItem && sibling.image_url) {
      if (img) {
        img.removeAttribute('srcset');
        img.src = sibling.image_url;
        if (pw && !pw.classList.contains('complete')) {
          pw.classList.add('complete');
        }
      }
    }

    if (gridItem && sibling.url) {
      gridItem.querySelectorAll('a[data-product-id]').forEach(a => { a.href = sibling.url; });
    }

    if (gridItem && sibling.price != null) {
      const moneyFormat = this.dataset.moneyFormat;
      const fmt = (cents) => Shopify?.theme?.tools?.formatMoney
        ? Shopify.theme.tools.formatMoney(cents, moneyFormat)
        : (cents / 100).toFixed(2);
      if (priceEl) {
        const hasDiscount = sibling.compare_at_price && sibling.compare_at_price > sibling.price;
        priceEl.innerHTML = hasDiscount
          ? `<span class="sale-price">${fmt(sibling.price)}&nbsp;</span><span class="compare-price">${fmt(sibling.compare_at_price)}</span>`
          : fmt(sibling.price);
      }
      const unitPriceEl = gridItem.querySelector('.grid-item-variant-unit-price');
      if (unitPriceEl) {
        if (sibling.unit_price != null && sibling.unit_price_base_unit) {
          unitPriceEl.textContent = `${fmt(sibling.unit_price)} / ${sibling.unit_price_base_unit}`;
        } else {
          unitPriceEl.textContent = '';
        }
      }
      gridItem.querySelectorAll('.grid-item-club-member-price-wrapper').forEach(clubEl => {
        const hasClubPrice = sibling.club_price != null;
        clubEl.hidden = !hasClubPrice;
        const clubPriceEl = clubEl.querySelector('.club-member-price');
        const clubInfoTextEl = clubEl.querySelector('.club-member-info-text');
        if (clubPriceEl) {
          clubPriceEl.textContent = hasClubPrice ? fmt(sibling.club_price) : '';
        }
        if (clubInfoTextEl) {
          clubInfoTextEl.textContent = sibling.club_text ?? '';
        }
      });
    }
  }
  setProduct(productUrl, variantSku) {
    if (!this.hasAttribute("external")){
      this.updateURL(productUrl);
    }
    this.updateDOM(productUrl, variantSku);
  }
}
if(!customElements.get("product-picker")){
  customElements.define("product-picker", ProductPicker);
}